import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NumericInput } from './numeric-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  providers: [],
  exports: [NumericInput],
  declarations: [NumericInput],
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
})
export class NumericInputModule {
  constructor() {}
}
